import axios from 'axios';

// 1. Create Axios Instance
const api = axios.create({
  // ✅ THE FIX: Use a relative path so Nginx handles the routing
  baseURL: '/api', 
  headers: {
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': 'true', 
  },
  timeout: 30000,
});
// 2. Request Interceptor: Attach Auth Token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      // Standard Bearer token format for JWT authentication
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('[API Request Error]', error);
    return Promise.reject(error);
  }
);

// 3. Response Interceptor: Handle Global Errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if error response exists before accessing status
    if (error.response) {
      // If 401 Unauthorized, token is invalid, expired, or missing
      if (error.response.status === 401) {
        console.warn('[API] Session expired or unauthorized. Redirecting to login.');
        
        // Clean up all user-related data from local storage
        const keysToRemove = ['token', 'username', 'role', 'api_key', 'balance'];
        keysToRemove.forEach(key => localStorage.removeItem(key));

        // Prevent infinite redirect loops if already on login page
        if (window.location.pathname !== '/login') {
           window.location.href = '/login';
        }
      }
    } else if (error.request) {
      // ✅ Handle Ngrok/Network timeouts gracefully so the UI doesn't crash
      console.error('[API Network Error] The backend is unreachable or Ngrok timed out.');
    }
    
    return Promise.reject(error);
  }
);

export default api;
